// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-31ce160e] .el-badge__content{border:1px solid transparent!important}.notice-icon[data-v-31ce160e]{background-color:#f56c6c;border-radius:10px;color:#fff;display:inline-block;height:5px;line-height:5px;text-align:center;white-space:nowrap;width:5px;margin-right:5px}.ftz-16[data-v-31ce160e]{font-size:16px}.ftz-12[data-v-31ce160e]{font-size:12px}.notice-title[data-v-31ce160e]{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;width:250px}", ""]);
// Exports
module.exports = exports;
